/**
 * MET (Metriek) Module Seeds - Consolidated Index
 *
 * Modular seed structure matching GET/TGL pattern.
 * Each family is stored in its own JSON file.
 *
 * Phase H-6: Migrated from flat seed_MET.json to folder-based pattern.
 */

import MET_LEN_OMREKEN from './MET-LEN-OMREKEN.json'
import MET_GEW_OMREKEN from './MET-GEW-OMREKEN.json'
import MET_GEW_WEGEN from './MET-GEW-WEGEN.json'
import MET_OPP_RECHT from './MET-OPP-RECHT.json'
import MET_OMTREK_RECHT from './MET-OMTREK-RECHT.json'
import MET_OPP_DRIEHOEK from './MET-OPP-DRIEHOEK.json'
import MET_INH_BLOK from './MET-INH-BLOK.json'
import MET_OPP_SAMENGESTELD from './MET-OPP-SAMENGESTELD.json'
import MET_INH_LITER from './MET-INH-LITER.json'
import MET_OPP_LAND from './MET-OPP-LAND.json'
import MET_INH_CITER from './MET-INH-CITER.json'
import MET_MEETK_OMTREK from './MET-MEETK-OMTREK.json'
import MET_MEETK_OPP from './MET-MEETK-OPP.json'
import MET_SCHAAL_OPP from './MET-SCHAAL-OPP.json'
import MET_OPP_VIERKANT from './MET-OPP-VIERKANT.json'
import MET_COORDINATEN from './MET-COORDINATEN.json'

const MET_FAMILY_SEEDS = [
  { file: 'src/data/seeds/MET/MET-LEN-OMREKEN.json', data: MET_LEN_OMREKEN },
  { file: 'src/data/seeds/MET/MET-GEW-OMREKEN.json', data: MET_GEW_OMREKEN },
  { file: 'src/data/seeds/MET/MET-GEW-WEGEN.json', data: MET_GEW_WEGEN },
  { file: 'src/data/seeds/MET/MET-OPP-RECHT.json', data: MET_OPP_RECHT },
  { file: 'src/data/seeds/MET/MET-OMTREK-RECHT.json', data: MET_OMTREK_RECHT },
  { file: 'src/data/seeds/MET/MET-OPP-DRIEHOEK.json', data: MET_OPP_DRIEHOEK },
  { file: 'src/data/seeds/MET/MET-INH-BLOK.json', data: MET_INH_BLOK },
  {
    file: 'src/data/seeds/MET/MET-OPP-SAMENGESTELD.json',
    data: MET_OPP_SAMENGESTELD,
  },
  { file: 'src/data/seeds/MET/MET-INH-LITER.json', data: MET_INH_LITER },
  { file: 'src/data/seeds/MET/MET-OPP-LAND.json', data: MET_OPP_LAND },
  { file: 'src/data/seeds/MET/MET-INH-CITER.json', data: MET_INH_CITER },
  { file: 'src/data/seeds/MET/MET-MEETK-OMTREK.json', data: MET_MEETK_OMTREK },
  { file: 'src/data/seeds/MET/MET-MEETK-OPP.json', data: MET_MEETK_OPP },
  { file: 'src/data/seeds/MET/MET-SCHAAL-OPP.json', data: MET_SCHAAL_OPP },
  { file: 'src/data/seeds/MET/MET-OPP-VIERKANT.json', data: MET_OPP_VIERKANT },
  { file: 'src/data/seeds/MET/MET-COORDINATEN.json', data: MET_COORDINATEN },
] as const

const allQuestions = MET_FAMILY_SEEDS.flatMap(({ file, data }) =>
  data.questions.map((question: any) => ({ ...question, __sourceFile: file })),
)

export default {
  module: 'Metriek' as const,
  moduleCode: 'MET',
  version: '5.2-modular',
  taxonomyVersion: '4.1',
  questions: allQuestions,
}
